const normalizePath = (pathname = "") => String(pathname || "").toLowerCase();

const STRICT_FEATURE_KEYS = new Set([
  "useVoip",
  "useWallet"
]);

const normalizeFeatureValue = (value) => {
  if (value === true || value === false) return value;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "true") return true;
    if (normalized === "false") return false;
  }
  return value;
};

export const isPlanFeatureEnabled = (plan, featureKey) => {
  if (!featureKey) return true;
  if (Array.isArray(featureKey)) {
    return featureKey.every((key) => isPlanFeatureEnabled(plan, key));
  }
  if (!plan || typeof plan !== "object") return true;

  const moduleFlags = plan.moduleFlags || {};
  const rawValue =
    plan[featureKey] !== undefined && plan[featureKey] !== null
      ? plan[featureKey]
      : moduleFlags[featureKey];

  const normalizedValue = normalizeFeatureValue(rawValue);
  if (STRICT_FEATURE_KEYS.has(featureKey)) {
    return normalizedValue === true;
  }
  return normalizedValue !== false;
};

const ROUTE_FEATURE_RULES = [
  { prefix: "/", feature: "useDashboard", exact: true },
  { prefix: "/reports", feature: "useRelatorio" },
  { prefix: "/tickets", feature: "useTickets" },
  { prefix: "/support-tickets", feature: "useSuporte" },
  { prefix: "/equipes", feature: "useEquipe" },
  { prefix: "/financeiro", feature: "useFinanceiro", exact: true },
  { prefix: "/asaas-financial", feature: "useAsaas" },
  { prefix: "/bancario-cartoes", feature: "useBancarioCartoes" },
  { prefix: "/woocommerce", feature: "useWooCommerce" },
  { prefix: "/emails", feature: "useEmailModule" },
  { prefix: "/wallet-management", feature: "useWalletManagement" },
  { prefix: "/wallet-sector", feature: "useWallet" },
  { prefix: "/my-wallet", feature: "useWallet" },
  { prefix: "/schedules", feature: "useSchedules" },
  { prefix: "/social-triggers", feature: "useGatilho" },
  { prefix: "/social-posts", feature: "useRedeSocial" },
  { prefix: "/meeting-rooms", feature: "useMeetingRooms" },
  { prefix: "/flow-process", feature: "useFlowBuilder" },
  { prefix: "/pdv", feature: "usePdv" },
  { prefix: "/comida-na-porta", feature: "useComidaNaPorta" },
  { prefix: "/motoqueiro", feature: "useComidaNaPorta" },
  { prefix: "/erpfone", feature: ["useTelefonia", "useErpPhone"] },
  { prefix: "/voip", feature: ["useTelefonia", "useVoip"] },
  { prefix: "/agendacare", feature: "useAgendacare" },
  { prefix: "/odontocare", feature: "useOdontocare" },
  { prefix: "/petcare", feature: "usePetcare" },
  { prefix: "/rotsa_360", feature: "useRotaVendas360" },
  { prefix: "/barber", feature: "useBarber" },
  { prefix: "/consulta-processo", feature: "useConsultaProcesso" },
  { prefix: "/advoc360", feature: "useAdvoc360" },
  { prefix: "/messages-api", feature: "useExternalApi" },
  { prefix: "/group-management", feature: "useGroupManagement" },
  { prefix: "/analytics-template-whats", feature: ["useDashboard", "useAnalyticsTemplateWhats"] },
  { prefix: "/whatsapp-templates", feature: "useWhatsappTemplates" },
  { prefix: "/meta-ads", feature: ["useDashboard", "useMetaAds"] },
  { prefix: "/queue-integration", feature: "useIntegrations" },
  { prefix: "/portal-interno", feature: "useInternalPortal" },
  { prefix: "/files", feature: "useFileManager" },
  { prefix: "/kanban", feature: "useKanban" },
  { prefix: "/tagskanban", feature: "useKanban" },
  { prefix: "/prompts", feature: "useOpenAi" },
  { prefix: "/ai-agents", feature: "useOpenAi" },
  { prefix: "/ai-help-requests", feature: "useOpenAi" },
  { prefix: "/ai-secretaria", feature: "useOpenAi" },
  { prefix: "/ai-executive-office", feature: "useOpenAi" },
  { prefix: "/callcenter-central", feature: "useCallcenter" },
  { prefix: "/callcenter", feature: "useCallcenter" },
  { prefix: "/educare", feature: "useEducare" },
  { prefix: "/services", feature: "useServico" },
  { prefix: "/service-professionals", feature: "useServico" },
  { prefix: "/service-list", feature: "useServico" },
  { prefix: "/service-appointments", feature: "useServico" },
  { prefix: "/service-financial", feature: "useServico" },
  { prefix: "/service-messaging", feature: "useServico" },
  { prefix: "/service-queues", feature: "useServico" },
  { prefix: "/contact-lists", feature: "useCampaigns" },
  { prefix: "/campaigns", feature: "useCampaigns" },
  { prefix: "/group-campaigns", feature: "useGroupCampaigns" },
  { prefix: "/voice-campaigns", feature: "useVoiceCampaigns" },
  { prefix: "/campaign/", feature: "useCampaigns" },
  { prefix: "/email-campaigns", feature: "useEmailCampaign" },
  { prefix: "/evolution-interactives", feature: "useEvolution" },
  { prefix: "/moments", feature: "useDashboard" },
];

export const getPlanFeatureForPath = (pathname) => {
  const normalizedPath = normalizePath(pathname);
  const match = ROUTE_FEATURE_RULES.find(({ prefix, exact }) =>
    exact ? normalizedPath === prefix : normalizedPath.startsWith(prefix)
  );

  return match?.feature;
};

export const isPlanRouteEnabled = (pathname, plan) => {
  const feature = getPlanFeatureForPath(pathname);
  return isPlanFeatureEnabled(plan, feature);
};
